'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.toggleNav = twentyninetimes.toggleNav || function () {

    function init() {
        toggleNav();
    }

    function toggleNav() {
        const navToggle = document.querySelector('.js-site-nav-toggle'); // Desktop nav toggle
        const mobileNavToggle = document.querySelector('.mobile-sticky-action--nav'); // Mobile nav toggle
        const navClose = document.querySelector('.js-site-nav-close');
        const header = document.querySelector('.js-site-header');
        const nav = document.querySelector('.site-nav');
        const siteContent = document.querySelector('.site-content');
        const siteFooter = document.querySelector('.site-footer');
        const body = document.body;
        const menuItems = document.querySelectorAll(".menu-item.menu-item-has-children");

        // const isNewLayout = body.classList.contains('layout-2025-v2');

        // menuItems.forEach(menuItem => {
        //     const link = menuItem.querySelector("a.link-border");
        //     const subMenu = menuItem.querySelector(".sub-menu__inner");

        //     if (link && subMenu) {
        //         if (isNewLayout) {
        //             // Create a button for toggling the submenu if in the new layout
        //             const toggleButton = document.createElement("button");
        //             toggleButton.type = "button";
        //             toggleButton.textContent = link.textContent;

        //             menuItem.insertBefore(toggleButton, link);
        //             // link.style.display = "none";

        //             toggleButton.addEventListener("click", function (event) {
        //                 event.preventDefault();

        //                 if (subMenu.style.maxHeight) {
        //                     subMenu.style.maxHeight = null;
        //                     toggleButton.classList.remove("is-open");
        //                 } else {
        //                     toggleButton.classList.add("is-open");
        //                     subMenu.style.maxHeight = `${subMenu.scrollHeight}px`;
        //                 }
        //             });
        //         } else {
        //             // Hover behavior for older layout
        //             menuItem.addEventListener("mouseenter", () => {
        //                 subMenu.style.maxHeight = `${subMenu.scrollHeight}px`;
        //                 link.classList.add("is-open");
        //             });
        //             menuItem.addEventListener("mouseleave", () => {
        //                 subMenu.style.maxHeight = null;
        //                 link.classList.remove("is-open");
        //             });
        //         }
        //     }
        // });

        if (nav) {
            // Attach event listeners to both desktop and mobile nav toggles
            [navToggle, mobileNavToggle].forEach(toggle => {
                if (toggle) {
                    toggle.addEventListener('click', function () {
                        toggleMenu();
                    });
                }
            });

            // Attach event listener for the close button
            if (navClose) {
                navClose.addEventListener('click', function () {
                    closeNav();
                });
            }

            function toggleMenu() {
                const isOpen = nav.classList.toggle('is-open');

                // Set aria-expanded attribute for accessibility
                if (navToggle) {
                    navToggle.setAttribute('aria-expanded', isOpen);
                }
                if (mobileNavToggle) {
                    mobileNavToggle.setAttribute('aria-expanded', isOpen);
                }

                if (isOpen) {
                    // Add active class to nav and header when open
                    nav.classList.add('menu-active');
                    header.classList.add('menu-active');
                    body.classList.add('nav-active');

                    // Dynamically get the height of the nav
                    const navHeight = nav.offsetHeight;

                    // Apply translation
                    // check if the screen width is above 1400px and apply the transform
                    if (window.innerWidth > 1400) {
                        siteContent.style.transform = `translateY(${navHeight}px)`;
                        header.style.transform = `translateY(${navHeight}px)`;
                        siteFooter.style.transform = `translateY(${navHeight}px)`;
                    } else {
                      bodyScrollLock.disableBodyScroll(nav);
                    }

                    // Add outside click event listener to close menu
                    document.addEventListener('click', handleOutsideClick);
                } else {
                    // Close the menu if it's open
                    closeNav();
                }
            }

            function handleOutsideClick(event) {
                // Close the menu if clicking outside the nav and toggles
                if (!nav.contains(event.target) && !navToggle.contains(event.target) && !mobileNavToggle.contains(event.target)) {
                    closeNav();
                }
            }

            function closeNav() {
                // Reset transforms
                if (window.innerWidth > 1400) {
                    
                    siteContent.style.transform = `translateY(0)`;
                    header.style.transform = `translateY(0)`;
                    siteFooter.style.transform = `translateY(0)`;
                }
                
                // Remove active classes
                nav.classList.remove('menu-active');
                header.classList.remove('menu-active');
                nav.classList.remove('is-open');
                body.classList.remove('nav-active');
                body.classList.remove('no-scroll');
                body.style.overflow = '';


                bodyScrollLock.enableBodyScroll(nav);

                // Reset aria-expanded attributes
                if (navToggle) {
                    navToggle.setAttribute('aria-expanded', 'false');
                }
                if (mobileNavToggle) {
                    mobileNavToggle.setAttribute('aria-expanded', 'false');
                }

                // Remove outside click event listener
                document.removeEventListener('click', handleOutsideClick);
            }
        }
    }

    return {
        init: init
    };

}();
